import AdminApiClient from '@/utils/admin-api-client';
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import type { RouteMeta } from '@/types';

const apiClient = new AdminApiClient();

export default {
  /**
   * 认证中间件 - 检查用户是否已登录
   */
  async auth(
    to: RouteLocationNormalized, 
    _: RouteLocationNormalized,
    next: NavigationGuardNext
  ): Promise<void> {
    // 如果不需要认证，直接通过
    const meta = to.meta as RouteMeta;
    if (meta.requiresAuth === false) {
      next();
      return;
    }
    
    // 检查是否已登录
    if (!apiClient.isLoggedIn()) {
      next({ name: 'login' });
      return;
    }
    
    next();
  },
  
  /**
   * 游客中间件 - 只允许未登录用户访问
   */
  guest(
    __: RouteLocationNormalized,
    _: RouteLocationNormalized,
    next: NavigationGuardNext
  ): void {
    if (apiClient.isLoggedIn()) {
      next({ name: 'dashboard' });
    } else {
      next();
    }
  }
};
